import { render, staticRenderFns } from "./schedule_formanswer_competition.vue?vue&type=template&id=2b8c5e76&scoped=true&"
import script from "./schedule_formanswer_competition.vue?vue&type=script&lang=js&"
export * from "./schedule_formanswer_competition.vue?vue&type=script&lang=js&"
import style0 from "./schedule_formanswer_competition.vue?vue&type=style&index=0&id=2b8c5e76&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c5e76",
  null
  
)

export default component.exports